import React from 'react';
import { Button } from '../../components/Button'; // Adjust the import path as necessary
import { colors } from '../../constants/colors'; // Adjust the import path as necessary

interface ConfirmationModalProps {
    isVisible: boolean;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    buttonSecond?: string;
}

const AcknowledgementModel: React.FC<ConfirmationModalProps> = ({
    isVisible,
    message,
    onConfirm,
    onCancel,
    buttonSecond = 'Ok',
}) => {
    if (!isVisible) {
        return null; // Return null when modal is not visible
    }

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-8 rounded-lg shadow-lg w-3/4 max-w-2xl relative flex flex-col">
                <h2 className="text-2xl font-bold mb-4">Confirmation</h2>
                <p className="mb-6 text-lg">{message}</p>
                {/* Positioned at the bottom-right corner with proper spacing */}
                <div className="mt-auto flex justify-end gap-4">
                    <Button
                        onClick={onConfirm}
                        className="w-full md:w-48 font-semibold mx-auto py-2"
                        style={{ 
                          whiteSpace: "nowrap", 
                          minWidth: "150px", 
                          backgroundColor: colors.darkGrey, // Add styles directly
                          color: "white" 
                        }}
                        variant="contained"
                        color="darkGrey"
                    >
                        {buttonSecond}
                    </Button>
                </div>
            </div>
        </div>
    );
};


export default AcknowledgementModel